import React from 'react';

import PropTypes from 'prop-types';
import {ToggleButtonGroup, ToggleButton} from 'react-bootstrap';

import './ToggleButtonCustom.less';

class ToggleButtonCustom extends React.Component {
  // Keep the button hilight, when button disabled is clicked
  clickDisabled = (e) => {
    const {buttonProp, value} = this.props;
    if (buttonProp === undefined || value === undefined) return;
    const {id} = e.currentTarget;
    // remove active classname at disabled button
    document.getElementById(id).className = document.getElementById(id).className.replace(' active', '');
    let activeId;
    for (let i = 0; i < buttonProp.length; i++) {
      if (buttonProp[i].value === value) {
        activeId = buttonProp[i].id === undefined ? buttonProp[i].label : buttonProp[i].id;

        break;
      }
    }

    // ConsoleLog("clickDisabled", buttonProp, value);
    if (activeId === undefined) return;
    // Set active classname back

    document.getElementById(activeId).className = document.getElementById(activeId).className.concat(' active');
  };

  // eslint-disable-next-line class-methods-use-this
  onChange = () => {};

  render() {
    const {buttonProp, defaultValue, value, onClick, vertical, disabled, className, block} = this.props;
    const listField =
      buttonProp === null
        ? false
        : buttonProp.map((button, index) => {
            // bug react bootsrap toggle button
            // when button is disable, class active still updated
            // var disabledClassName = button.disabled
            //   ? value === button.value
            //     ? " highlight "
            //     : " toggleButtonDisabled "
            //   : button.disabled
            //   ? value === button.value
            //     ? " highlight "
            //     : " toggleButtonDisabled "
            //   : "";
            const buttonSizeClassName = button.customButtonSize ? '' : 'toggleButtonDefaultSize ';
            // eslint-disable-next-line no-nested-ternary
            const toggleBorder = index > 0 ? (vertical ? '' : ' toggleButton-border ') : '';
            const verticalClassName = vertical ? 'verticalClassName ' : '';
            // var isActive = value === button.value ? "checked " : "unchecked ";
            const buttonAddionalClassName = button.className !== undefined ? `${button.className} ` : '';
            const activeClassname = button.value === value ? 'active' : '';

            return (
              <ToggleButton
                className={'toggleButton '
                  // .concat(disabledClassName)
                  .concat(buttonSizeClassName)
                  .concat(toggleBorder)
                  .concat(verticalClassName)
                  .concat(buttonAddionalClassName)
                  // .replace('active', '')
                  .concat(activeClassname)}
                key={button.label}
                id={button.id === undefined ? button.label : button.id}
                value={button.value || button.id}
                onClick={button.disabled ? this.clickDisabled : onClick}
                // checked={value === button.value}
                disabled={button.disabled}
              >
                {button.icon === undefined && <span>{button.label.toUpperCase()}</span>}
                {button.icon !== undefined && (
                  <img
                    src={button.icon}
                    alt={button.icon}
                  />
                )}
              </ToggleButton>
            );
          });
    return (
      <div
        className={vertical ? 'ToggleButtonVertical' : 'ToggleButtonCustom'.concat(disabled ? ' disabledPointer' : '')}
      >
        {/* Without onChange, will rise this warning, but i don't know the method not fire */}
        {/*
                    Warning: Failed prop type: You have provided a `value` prop to `ToggleButtonGroup` without an `onChange` 
                    handler prop. This will render a read-only field. If the field should be mutable use `defaultValue`.
                     Otherwise, set `onChange`.
                */}
        <ToggleButtonGroup
          justified={!vertical} // horizontal
          vertical={vertical}
          block={block}
          type="radio"
          name="options"
          defaultValue={defaultValue}
          value={value}
          onChange={this.onChange}
          className={className || ''}
        >
          {listField}
        </ToggleButtonGroup>
      </div>
    );
  }
}

ToggleButtonCustom.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  vertical: PropTypes.bool,
  block: PropTypes.any,
  buttonProp: PropTypes.array,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
};

ToggleButtonCustom.defaultProps = {
  onClick: () => {},
  id: '',
  label: '',
  className: '',
  disabled: false,
  vertical: false,
  block: null,
  buttonProp: [],
  defaultValue: null,
  value: null,
};

export default ToggleButtonCustom;
